<template>
    <a-modal name="authPage-modal">
        <div class="AuthPageContainer">
            <div class="AuthPageContainer__head">
                <div class="container">
                    <div class="logo"></div>
                    <div class="back" @click="hide">{{params.messages.back}}</div>
                </div>
            </div>
            <div class="AuthPageContainer__top"></div>
            <div class="AuthPageContainer__bottom"></div>
            <div class="AuthPageContainer__contentWrapper">
                <div class="AuthPageContainer__content">
                    <component :is="currentComponent" :params="params"/>
                </div>
            </div>
        </div>
    </a-modal>
</template>

<script>
import {ref, computed, onMounted, defineAsyncComponent} from 'vue'
import {useStore, mapState} from 'vuex';
import {AModal, useAModal} from '~/components/ui'
import {AUTH_STATES} from "../store/modules/auth";

export default {
    name: "AuthPageContainer",

    props: ['params'],

    components: {
        AModal,
    },

    setup() {
        const $store = useStore();
        const {show, hide} = useAModal();


        const currentComponent = computed(() => {
            switch ($store.state.auth.authState) {
                case AUTH_STATES.login:
                    return defineAsyncComponent(() => import('~/components/forms/auth/LoginForm'))

                case AUTH_STATES.registration:
                    return defineAsyncComponent(() => import('~/components/popups/RegisterPopup'))

                case AUTH_STATES.restore:
                    return defineAsyncComponent(() => import('~/components/forms/auth/RestorePasswordForm'))

                default:
                    return defineAsyncComponent(() => import('~/components/forms/auth/LoginForm'))
            }
        })

        return {
            show,
            hide,
            currentComponent,
        }
    }
}
</script>

<style scoped lang="scss">
.AuthPageContainer {
    position: relative;
    height: 100vh;
    width: 100vw;
    z-index: 1000;

    &__top {
        background-color: var(--c-gray-800);
        height: calc(32% - rem(100));
    }

    &__bottom {
        background-color: #fff;
        height: 68%;
    }

    &__contentWrapper {
        display: flex;
        position: absolute;
        left: 0;
        top: 100px;
        width: 100vw;
        height: 100vh;
        background-color: transparent;
        justify-content: center;
        align-items: center;

        @include mobile {
        }
    }

    &__content {
        margin-top: -100px;
    }

    &__head {
        border-bottom: 1px solid var(--c-gray-700);
        padding: rem(25) 0;
        background-color: var(--c-gray-800);
        height: rem(100);

        .logo {
            display: block;
            width: rem(93);
            height: rem(50);
            background-image: url("/local/templates/main/img/logo.svg");
            background-size: contain;
            background-position: center;
            background-repeat: no-repeat;
        }

        .back {
            font-weight: 400;
            font-size: rem(14);
            line-height: rem(20);
            color: var(--c-gray-500);
            cursor: pointer;

            &:hover {
                color: var(--c-gray-400);
            }
        }
    }

    &__head > div {
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    ::v-deep .a-checkbox {
        margin-top: 0;
    }

    ::v-deep .register-popup {
        position: absolute;
        top: -100px;
        left: 0;
        width: 100vw;
        height: 100vh;
    }
}
</style>